// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"ed86b9c0","551":"0d5961ec"}[chunkId] + ".chunk.css";
};